import { faListUl } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * ProviderList item interface for ui_metadata storage
 */
export interface ProviderListItem {
  id: string;
  displayLabel: string;
  label: string;
  num_items?: number;
}

/**
 * Transform API response (MedScout.List) to ProviderListItem format
 */
export const transformProviderList = (apiItem: {
  id: string | number;
  name?: string;
  label?: string;
  num_items?: number;
}): ProviderListItem => ({
  id: String(apiItem.id),
  displayLabel: apiItem.name || apiItem.label || String(apiItem.id),
  label: apiItem.name || apiItem.label || String(apiItem.id),
  num_items: apiItem.num_items,
});

/**
 * Modal configuration for ProviderList selector
 */
export const providerListModalConfig: GenericSelectorModalConfig<ProviderListItem> =
  {
    title: 'Select Provider Lists',
    searchPlaceholder: 'Search provider lists...',
    emptyStateIcon: faListUl,
    emptyStateMessage: 'No provider lists selected',
    noResultsMessage: (searchTerm) =>
      `No provider lists found for "${searchTerm}"`,
    colorTheme: 'lime',
    selectionMode: 'multiple',
    showConnectorToggle: true,
    defaultConnector: 'ANY',
    getItemLabel: (item) => item.label,
    getItemKey: (item) => item.id,
    isItemSelected: (item, selectedItems) =>
      selectedItems.some((s) => s.id === item.id),
    getItemSecondaryLabel: (item) =>
      item.num_items != null ? `${item.num_items} providers` : null,
    itemLabel: 'provider list',
    itemLabelPlural: 'provider lists',
  };

/**
 * Node display configuration for ProviderList
 */
export const providerListNodeConfig: GenericNodeComponentConfig<ProviderListItem> =
  {
    colorTheme: 'lime',
    getItemLabel: (item) => item.label,
    getItemKey: (item) => item.id,
    maxVisibleItems: 3,
    showConnectorLabel: true,
  };
